module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-highlight-32.1eec3c53.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-highlight-32.png
// module id = 3175
// module chunks = 11